module.exports = __webpack_public_path__ + "img/avbi03b.32b5dd70.png";